import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert,
  AlertTitle,
} from '@mui/material';
import { AlertTriangle } from 'react-feather';

type ClioConnectionBlockModalProps = {
  open: boolean;
  manageAccountName: string;
  draftOrgManageAccountName: string;
  handleDismiss: () => void;
};

const ClioConnectionBlockModal = ({
  open,
  manageAccountName,
  draftOrgManageAccountName,
  handleDismiss,
}: ClioConnectionBlockModalProps) => {
  return (
    <Dialog open={open} onClose={handleDismiss}>
      <DialogTitle>
        <div className="flex flex-col">
          <span className="text-lg font-semibold text-red-600">
            Unable to connect your Clio Manage account to Clio Draft{' '}
          </span>
        </div>
      </DialogTitle>
      <DialogContent dividers={true}>
        <div className="flex flex-col space-y-4">
          <Alert
            sx={(theme) => ({
              padding: theme.spacing(0.5, 2),
              background: theme.palette.yellow[50],
              color: theme.palette.text.primary,
              '.MuiAlert-icon': {
                color: theme.palette.text.primary,
              },
            })}
            icon={<AlertTriangle fontSize="inherit" />}
            severity="warning"
          >
            <AlertTitle>Organization mismatch</AlertTitle>
            The Clio Manage account <strong>{manageAccountName}</strong> does
            not match the organization associated with your Clio Draft account,{' '}
            <strong>{draftOrgManageAccountName}</strong>. You can only connect
            to a matching organization.
          </Alert>
          <div className="text-sm text-gray-600">
            <p className="mb-2">To resolve this issue:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>
                Confirm you are logged into the correct Clio Manage account.
              </li>
              <li>
                Check that your Clio Draft organization is the same as your Clio
                Manage organization.
              </li>
              <li>
                Contact support if you need assistance with account linking
              </li>
            </ul>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss} variant="contained" color="primary">
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClioConnectionBlockModal;
